import apiWrapper from '../../services/apiWrapper';

const logVisitor = async () => {
  try {
    const response = await apiWrapper('post', '/log', {
      path: window.location.pathname
    });

    return {
      success: true,
      message: response.message
    };
  } catch (error) {
    console.error('Error logging visitor:', error.message);
    return {
      success: false,
      message: 'Failed to log visitor.'
    };
  }
};

export default logVisitor;